import React, { Fragment,  useContext, useEffect } from 'react'
import operatorContext from '../../../context/operator/operatorContext'
import {useAlert} from "react-alert";

const OperatorProfile = () => {

    const OperatorContext = useContext(operatorContext);

    const { updateOperatorProfile, operator, clearAlert } = OperatorContext;

    const { message } = operator

    const alert = useAlert()

    //Get userInfo
    var userInfo = JSON.parse(localStorage.getItem('userInfo'))

    useEffect(() => {

        
        if (message.msg !== "") {
            alert.show(
                message.msg, message.msg_options
            )
            clearAlert()
        }

        //eslint-disable-next-line
    }, [OperatorContext]);

    const onSubmit = e => {

        e.preventDefault()

        let edit_profile_form = document.getElementById("edit_profile_form");

        let updated_profile = new FormData(edit_profile_form);
        updateOperatorProfile(updated_profile)
    }

    return (
        <Fragment>
            <div className="content-wrapper">
            <div className="container-fluid">
                <h3 className="make-bold">Profile Settings</h3>
                <p>Update your personal and business information</p>
                {/* <!--Start Dashboard Content--> */}

                <div className="dashboard-inner-view">
                    <div className="row mt-3">
                        <div className="col-lg-8">

                            <ul className="profile-tab-view nav nav-pills mb-5" id="pills-tab" role="tablist">
                                <li className="nav-item">
                                    <a className="nav-link active ft-1-5" id="pills-personal-information-tab"
                                        data-toggle="pill" href="#pills-personal-information" role="tab"
                                        aria-controls="pills-personal-information" aria-selected="true">Personal
                                        Information</a>
                                </li> 
                            </ul>
                            <div className="tab-content" id="pills-tabContent">

                                <div className="tab-pane fade show active" id="pills-personal-information" role="tabpanel"
                                    aria-labelledby="pills-home-tab">
                                    <div className="profile-info-details">
                                        <div className="row">
                                            <div className="col-lg-7">
                                                <form onSubmit={onSubmit} id="edit_profile_form">
                                                    <div className="form-group mb-5">
                                                        <label>First Name</label>
                                                        <input type="text" className="form-control form-control-custom-view"
                                                            name='first_name'
                                                            defaultValue={userInfo && userInfo.first_name} required />
                                                    </div>
                                                    <div className="form-group mb-5">
                                                        <label>Last Name</label>
                                                        <input type="text" className="form-control form-control-custom-view"
                                                             name='last_name'
                                                            defaultValue={userInfo && userInfo.last_name} required />
                                                    </div>
                                                    <div className="form-group mb-5">
                                                        <label>Phone Number</label>
                                                        <input type="text"
                                                            className="form-control form-control-custom-view"
                                                             name='phone'
                                                            defaultValue={userInfo && userInfo.phone} required/>
                                                    </div>
                                                    <div className="form-group mb-5">
                                                        <label>Business Name</label>
                                                        <input type="text"
                                                            className="form-control form-control-custom-view"
                                                             name='business_name'
                                                             required/>
                                                    </div>
                                                    <div className="form-group mb-5">
                                                        <label>Address</label>
                                                        <textarea className="form-control form-control-custom-view" rows="5"
                                                           name='address'
                                                           defaultValue={userInfo && userInfo.address} ></textarea>
                                                    </div>
                                                    <input type="hidden" name="state_id" defaultValue={userInfo && userInfo.state_id} />
                                                    <input type="hidden" name="lga_id" defaultValue={userInfo && userInfo.lga_id} />
                                                    <div className="form-row">
                                                        <div className="form-group col-lg-4">
                                                            <input type="submit" defaultValue="UPDATE" 
                                                                className="btn btn-orange btn-custom-view text-white btn-block d-flex justify-content-center align-items-center"
                                                                />
                                                           
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                            <div className="col-lg-3">
                                                <a href="!#">
                                                    <div className="position-relative">
                                                        <div className="avatar-holder-profile bord-radius-50 mx-auto">
                                                            <img src="assets/images/avatar-big.png"
                                                                className="img-fluid object-fit-cover object-pos-center h-100 w-100" alt="" />
                                                        </div>
                                                        <img src="assets/images/vector-avatar.png"
                                                            className="img-fluid vector-avatar-overlay" alt="" />
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <!--End Dashboard Content--> */}

            </div>
            {/* <!-- End container-fluid--> */}

        </div>
        {/* End wrapper */}
       
        </Fragment>
    )
}

export default OperatorProfile
